export default "__VITE_ASSET__6fa2258b__"